import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = `${baseUrl}/bookmark`;

export default {
  /**
   * 유효한 트리키인지 확인한다.
   * 유효한 트리키일 경우 true, 그렇지 않으면 false를 반환한다.
   * @author Ju
   * @param  {String} treeType 트리 타입
   * @param  {String} treeKey  트리키
   * @return {[type]}          [description]
   */
  checkValidTreeKey(treeType, treeKey) {
    return axios.get(`${PREFIX_URL}/check-valid-treekey.do`, {
      params: { treeType, treeKey },
    });
  },
  /**
   * 자주 방문하는 경로 정보를 추가 / 수정한다.
   * @author Ju
   * @param  {Object} 자주 방문하는 경로 파라미터 객체
   * @return {[type]}      [description]
   */
  updateFrequentlyVisitPath(params) {
    return axios.post(`${PREFIX_URL}/update-frequently-visit-path.do`, params);
  },
  /**
   * 계정별 즐겨찾기 목록을 조회한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBookmarkTree(params) {
    return axios.get(`${PREFIX_URL}/get-bookmark-tree.do`, { params });
  },
  /**
   * 즐겨찾기 항목을 삭제한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteBookmarkInfo(params) {
    return axios.post(`${PREFIX_URL}/delete-bookmark-info.do`, params);
  },
  /**
   * 자주 방문하는 페이지 목록을 조회한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFrequentlyPageList(params) {
    return axios.post(`${PREFIX_URL}/get-frequently-page-list.do`, params);
  },
  /**
   * 즐겨찾기를 추가한다.
   * @author yelim
   * @param  {[type]} params [description]
   */
  setBookmarkInfo(params) {
    return axios.post(`${PREFIX_URL}/set-bookmark-info.do`, params);
  },
  /**
   * 자주 방문하는 페이지를 삭제한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteFrequentlyPage(params) {
    return axios.post(`${PREFIX_URL}/delete-frequently-page.do`, params);
  },
  /**
   * 즐겨찾기 이름, 추가, 삭제 순서 변경을 수행한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  editBookmarkInfo(params) {
    return axios.post(`${PREFIX_URL}/edit-bookmark-info.do`, params);
  },
  getBookmarkInfo() {
    return axios.get(`${PREFIX_URL}/get-bookmark-info.do`);
  },
  /**
   * 정리 조건에 따라 즐겨찾기 목록을 조회한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBookmarkCleanupCondition(params) {
    return axios.post(`${PREFIX_URL}/get-bookmark-cleanup-condition.do`, params);
  },
  /**
   * 선택한 정리 조건에 따라 즐겨찾기 목록을 삭제한다.
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  cleanupBookmarkInfo(params) {
    return axios.post(`${PREFIX_URL}/cleanup-bookmark-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/bookmark.js